import { NumericFormat } from "react-number-format";
import TextField from "@mui/material/TextField";

/**
 * MUI TextField con formato de moneda argentina ($ 1.234,56).
 *
 * Props clave:
 *  - value: número o string numérico
 *  - onValueChange({ floatValue, formattedValue }): callback al cambiar
 *  - Todas las props de MUI TextField (label, size, fullWidth, error, helperText, etc.)
 *
 * Ejemplo:
 *   <CurrencyInput
 *     label="Monto"
 *     value={amount}
 *     onValueChange={({ floatValue }) => setAmount(floatValue ?? 0)}
 *     fullWidth
 *   />
 */
export default function CurrencyInput({ onValueChange, ...props }) {
  return (
    <NumericFormat
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      prefix="$ "
      allowNegative={false}
      customInput={TextField}
      onValueChange={onValueChange}
      {...props}
    />
  );
}
